import { withDependencies } from '@wix/thunderbolt-ioc'
import { ReactTemplateSymbol } from './symbols'
import type { ReactTemplate } from './types'
import {
	getReactModuleCode,
	getReactDOMModuleCode,
	getReactJsxRuntimeCode,
	getReactJsxDevRuntimeCode,
	getPreactSignalsReactModuleCode,
} from './reactTemplate'

export const ReactTemplateFactory = withDependencies([], (): ReactTemplate => {
	return {
		getReactModuleCode,
		getReactDOMModuleCode,
		getReactJsxRuntimeCode,
		getReactJsxDevRuntimeCode,
		getPreactSignalsReactModuleCode,
	}
})
